import React from "react";
import ChoirSection from "./../components/ChoirSection";

function ChoirPage(props) {
  return (
    <ChoirSection
      bgColor="light"
      size="medium"
      bgImage=""
      bgImageOpacity={1}
      title="Saint Kyrel Choir"
      subtitle=""
    />
  );
}

export default ChoirPage;
